<div>
    <div class="top-bar">
        <h2 class="global-title">
            Booking Requests
        </h2>
        <div class="top-bar-buttons-container">
            <p-button label="Create a booking" routerLink="/management/create-single-booking"></p-button>
        </div>
    </div>
    <app-wp-booking-requests></app-wp-booking-requests>
</div>
